/**
 * Генерирует детерминированный seed из roomId.
 * Один и тот же roomId всегда даёт один и тот же seed.
 */
export function seedFromRoomId(roomId: string): number {
  let hash = 0;
  for (let i = 0; i < roomId.length; i++) {
    const char = roomId.charCodeAt(i);
    hash = ((hash << 5) - hash) + char;
    hash = hash & hash; // Convert to 32bit integer
  }
  // Делаем положительным
  return Math.abs(hash);
}
